import React from 'react';

import { Name } from '~src/app/spaces/Tooltips/Elements/Name';
import { Timestamp } from '~src/app/spaces/Tooltips/Elements/Timestamp';
import { Tooltip } from '~src/app/spaces/Tooltips/Elements/Tooltip';
import { User } from '~src/app/spaces/Tooltips/Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from '~src/app/spaces/Tooltips/TooltipHelper';
import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';

export function CollectionTooltip(props: ContentTooltipProps): JSX.Element {

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <User user={props.content.owner} label={Messages.owner()} urls={props.urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
